import * as types from './types';
import { loading } from '../actions';

export const getGradesAction = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GRADES_LOAD, true));

    try {
      const response = await MPWWebApi.getGeneric('grade');
      dispatch({
        type: types.GET_GRADES,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: types.GET_GRADES_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.GRADES_LOAD, false));
  };
};



// WEBPACK FOOTER //
// ./src/state/grades/actions.js